// TODO: Default enable an extension demo based on the browser
// TODO: verify URL and provide error messages
import { Link, useLocation } from 'react-router-dom';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import logo from '../../sidebar-logo.png';
import screenshot from './screenshot.png';
import applepodcasts from '../../Assets/podcast-apps/icon-applepodcasts.svg';
import breaker from '../../Assets/podcast-apps/icon-breaker.svg';
import castbox from '../../Assets/podcast-apps/icon-castbox.svg';
import googlepodcasts from '../../Assets/podcast-apps/icon-googlepodcasts.svg';
import overcast from '../../Assets/podcast-apps/icon-overcast.svg';
import playerfm from '../../Assets/podcast-apps/icon-playerfm.svg';
import pocketcasts from '../../Assets/podcast-apps/icon-pocketcasts.svg';
import radiopublic from '../../Assets/podcast-apps/icon-radiopublic.svg';
import castro from '../../Assets/podcast-apps/icon-castro.svg';
import podbean from '../../Assets/podcast-apps/icon-podbean.svg';
import downcast from '../../Assets/podcast-apps/downcast.png';
import podcastRepublic from '../../Assets/podcast-apps/podcastRepublic.png';
import podcastAddict from '../../Assets/podcast-apps/podcastAddict.png';
import thePodcastApp from '../../Assets/podcast-apps/the-podcast-app.png';
import spotify from '../../Assets/podcast-apps/Spotify_icon.svg';
import airr from '../../Assets/podcast-apps/airr.svg';
import youtube from '../../Assets/podcast-apps/icon-youtube.svg';
import Chrome from '../../Assets/chrome.svg';
import Safari from '../../Assets/safari.svg';
import Article from './Components/Article';
import mixpanel from 'mixpanel-browser';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import YouTubeIcon from '@mui/icons-material/YouTube';
import {
  isAndroid,
  isIOS,
  isEdge,
  isMobile,
  isChrome,
} from 'react-device-detect';
import Player from '../../Components/PlayerNew';
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
} from '@mui/icons-material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import BookIcon from '@mui/icons-material/Book';
import { observer } from 'mobx-react';
import { publish, subscribe, unsubscribe } from '../../PlayerPubSub';
import userStore from '../../Stores/User';
import pricingStore from '../../Stores/PricingStore';
import { isPaidProUser, hasPaidPlan } from '../../constants/plans';
import { logExperimentView, logConversion } from '../../firebase';
import { CircularProgress } from "@mui/material";
import { getAllFeeds, getLatestFeedArticleFromFeed } from "../../audiblogsApi";
import FeedSubscribed from "../../Pages/DiscoverNew/Components/FeedSubscribed";
import { setLandingPage } from '../../utils/trackingParams';

import './landingA.scss';  // Create a separate stylesheet for variant B
import YoutubeIframe from "./Components/YoutubeIframe";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import OneGiftLogo from '../../Components/OneGiftLogo';
import blogIcon from '../../Pages/DiscoverNew/Icons/blog.png';
import newsletterIcon from '../../Pages/DiscoverNew/Icons/newsletter.png';
import PricingCards from '../../Components/PricingCards';
import Testimonials from './Components/Testimonials';

const SexyArrow = ({ style = {} }) => (
  <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M2 12H32M32 12L25 5M32 12L25 19" stroke="#4292fa" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ProBadge = observer(() => {
    const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
      ? isPaidProUser(userStore.user)
      : false;
    const hasPlan = hasPaidPlan(userStore.user);
  
    const [showPopover, setShowPopover] = useState(false);
  
    const badgeStyle = {
      background: isProUser 
        ? 'linear-gradient(135deg, #CB5EEE 0%, #4BE1EC 100%)' 
        : hasPlan 
          ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
          : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
      padding: '2px 6px',
      borderRadius: '8px',
      fontSize: '11px',
      fontWeight: 'bold',
      position: 'absolute',
      top: isProUser ? '35px' : '0px',
      left: '45px',
      display: 'inline-flex',
      alignItems: 'center',
      height: '16px',
      width: isProUser ? '32px' : hasPlan ? '70px' : '95px',
      justifyContent: 'center',
      cursor: isProUser ? 'default' : 'pointer',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      color: 'white'
    };
  
    const popoverStyle = {
      position: 'absolute',
      top: '25px',
      left: '45px',
      background: 'rgba(0, 0, 0, 0.9)',
      padding: '8px 12px',
      borderRadius: '8px',
      fontSize: '12px',
      width: '200px',
      color: 'white',
      zIndex: 1000,
      pointerEvents: 'none',
      opacity: showPopover ? 1 : 0,
      transition: 'opacity 0.2s ease-in-out',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      backdropFilter: 'blur(5px)'
    };
  
    if (!userStore.user) return null;
  
    if (isProUser) {
      return (
        <div style={badgeStyle}>
          PRO
        </div>
      );
    }
  
    if (hasPlan) {
      return (
        <div style={{ position: 'relative' }}>
          <a 
            href={userStore.customerPortalUrl} 
            target="_blank" 
            rel="noreferrer"
            style={badgeStyle}
            onMouseEnter={() => setShowPopover(true)}
            onMouseLeave={() => setShowPopover(false)}
            onClick={(e) => {
              if (!userStore.customerPortalUrl) {
                e.preventDefault();
              }
            }}
          >
            UPGRADE
          </a>
          <div style={popoverStyle}>
            Upgrade to pro to get premium voices, other languages, and more!
          </div>
        </div>
      );
    }
  
    return (
      <div style={{ position: 'relative' }}>
        <Link 
          to="/onboarding/ChooseVoice" 
          style={badgeStyle}
          onMouseEnter={() => setShowPopover(true)}
          onMouseLeave={() => setShowPopover(false)}
        >
          START TRIAL
        </Link>
        <div style={popoverStyle}>
          Start your 7-day free trial today!
        </div>
      </div>
    );
  });
  
  const LandingB = observer(() => {
    const [deviceDemo, setDeviceDemo] = useState('chrome');
    const [selectedDemo, setSelectedDemo] = useState('');
    const [demoUrl, setDemoUrl] = useState('');
    const [audioLoading, setAudioLoading] = useState(false);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const desktopVideoRef = useRef(null);
    const mobileVideoRef = useRef(null);
    const imageRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [vipId, setVipId] = useState(queryParams.get('vip'));
    const [cta, setCta] = useState("Start listening");
    const [lanSupport, setLanSupport] = useState("");
    const supportedLaguages = {
      "af": "Afrikaans",
      "am": "Amharic",
      "ar": "العربية",
      "az": "Azərbaycan dili",
      "bg": "български",
      "bn": "বাংলা",
      "bs": "bosanski",
      "ca": "Català",
      "cs": "čeština",
      "cy": "Cymraeg",
      "da": "Dansk",
      "de": "Deutsch",
      "el": "Ελληνικά",
      "es": "Español",
      "et": "eesti",
      "eu": "euskara",
      "fa": "فارسی",
      "fi": "suomi",
      "fil": "Filipino",
      "fr": "Français",
      "ga": "Gaeilge",
      "gl": "galego",
      "gu": "ગુજરાતી",
      "he": "עברית",
      "hi": "हिन्दी",
      "hr": "hrvatski",
      "hu": "magyar",
      "hy": "հայերեն",
      "id": "Indonesia",
      "is": "íslenska",
      "it": "Italiano",
      "ja": "日本語",
      "jv": "Jawa",
      "ka": "ქართული",
      "kk": "қазақ тілі",
      "km": "ភាសាខ្មែរ",
      "kn": "ಕನ್ನಡ",
      "ko": "한국어",
      "lo": "ລາວ",
      "lt": "lietuvių",
      "lv": "latviešu",
      "mk": "македонски",
      "ml": "മലയാളം",
      "mn": "Монгол хэл",
      "mr": "मराठी",
      "ms": "Bahasa Melayu",
      "mt": "Malti",
      "my": "ဗမာစာ",
      "nb": "Norsk bokmål",
      "ne": "नेपाली",
      "nl": "Nederlands",
      "pl": "polski",
      "ps": "پښتو",
      "pt": "Português",
      "ro": "Română",
      "ru": "Русский",
      "si": "සිංහල",
      "sk": "slovenčina",
      "sl": "slovenščina",
      "so": "Soomaali",
      "sq": "Shqip",
      "sr": "српски",
      "su": "Basa Sunda",
      "sv": "Svenska",
      "sw": "Kiswahili",
      "ta": "தமிழ்",
      "te": "తెలుగ",
      "th": "ไทย",
      "tr": "Türkçe",
      "uk": "українська",
      "ur": "اردو",
      "uz": "Oʻzbekcha",
      "vi": "Tiếng Việt",
      "wuu": "吴语",
      "yue": "粤语",
      "zh": "中文",
      "zu": "isiZulu"
    };
    useEffect(() => {
      // Track page visit with consistent event name
      mixpanel.track('Landing Page Visited', {
        page: 'landing_b',
        variant: 'B',
        utm_landingpage: 'landing_b'
      });
      setLandingPage('landing_b');
      mixpanel.start_session_recording();

      // Track pricing display variant
      mixpanel.people.set({
        checkoutPricing: pricingStore.showOnlyPro ? 'pro_only' : 'all_plans'
      });
      mixpanel.track('Checkout Pricing Variant Shown', {
        variant: pricingStore.showOnlyPro ? 'pro_only' : 'all_plans'
      });

      if (vipId) {
        mixpanel.people.set_once({
          utm_source: "vip",
          vip_id: vipId,
        });
  
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/promo/is_vip_code_available/${vipId}`, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.is_vip_code_available) {
              userStore.updateVipId(vipId);
              setCta("Claim Lifetime Access")
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      // Set device demo based on platform
      if (isIOS) {
        onClickDemo('iOS');
      } else if (isAndroid) {
        onClickDemo('Android');
      } else {
        onClickDemo('Chrome');
      }
    }, [vipId]);
    const [popularArticles, setPopularArticles] = useState([
      {
        article_id: "https://www.bbc.co.uk/news/articles/cy4m84d2xz2o",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/f4dd27f6-d5dd-416b-b229-54b301eeb48c-0.mp3",
        thumbnail_url: "https://ichef.bbci.co.uk/ace/standard/976/cpsprodpb/84ff/live/1f881110-d87c-11ef-ac27-7d96dfc74407.jpg.webp",
        date_added: "2024-08-29T11:19:48.43Z",
        title: "Stargate: Tech giants announce AI plan worth up to $500bn",
        num_characters: 8945,
      },
      {
        article_id: "https://www.bbc.co.uk/news/articles/cy48v1x4dv4o",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/3a554731-3e87-4b06-8454-f28d46f6fbba-0.mp3",
        thumbnail_url: "https://ichef.bbci.co.uk/images/ic/320x180/p0kkzpkv.jpg.webp",
        date_added: "2024-09-08T11:12:16.80Z",
        title: "Musk responds to backlash over gesture at Trump rally",
        num_characters: 9391,
      },
      {
        article_id: "https://paulgraham.com/foundermode.html",
        audio_url: "https://unreal-expire-in-90-days.s3-us-west-2.amazonaws.com/38dc82de-2f76-4f67-8aec-a937db43bb79-0.mp3",
        thumbnail_url: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Y_Combinator_logo.svg/1200px-Y_Combinator_logo.svg.png",
        date_added: "2024-09-02T10:56:49.74Z",
        title: "Paul Graham's: Founder Mode",
        num_characters: 6986,
      },
    ]);
    const history = useHistory();
    const [isFullPlayer, updateIsFullPlayer] = useState(false);
    const [isPlayerEnabled, setIsPlayerEnabled] = useState(false);
  
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentArticle, setCurrentArticle] = useState({
      id: '',
      article_url: '',
      title: '',
      audio_url: '',
    });
  
    const selectArticle = (article) => {
      setCurrentArticle(article);
      setIsPlayerEnabled(true);
  
      setTimeout(
        () =>
          publish(
            isPlaying &&
              currentArticle &&
              currentArticle.article_id === article.article_id
              ? 'pause'
              : 'play'
          ),
        1
      );
    };
  
    useEffect(() => {

      // Set demo based on device
      if (isIOS) {
        onClickDemo('iOS');
      } else if (isAndroid) {
        onClickDemo('Android');
      } else {
        onClickDemo('Chrome');
      }

      // Handle video refs and playback
      if (desktopVideoRef.current && mobileVideoRef.current) {
        desktopVideoRef.current.onended = () => {
          desktopVideoRef.current.pause();
          desktopVideoRef.current.currentTime = desktopVideoRef.current.duration;
          mobileVideoRef.current.play();
        };

        mobileVideoRef.current.onended = () => {
          mobileVideoRef.current.pause();
          mobileVideoRef.current.currentTime = mobileVideoRef.current.duration;
          const videoSrc = desktopVideoRef.current.currentSrc;

          if (videoSrc.includes('1-540p.mp4')) {
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("1-cropped.jpg", "2-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('1-540p.mp4', '2-540p.mp4');
            desktopVideoRef.current.load();
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("1-cropped.mp4", "2-cropped.mp4");
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("1-cropped.jpg", "2-cropped.jpg");
            mobileVideoRef.current.load();
          } else if (videoSrc.includes('2-540p.mp4')) {
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("2-cropped.jpg", "3-cropped.jpg");
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("2-cropped.jpg", "3-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('2-540p.mp4', '3-540p.mp4');
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("2-cropped.mp4", "3-cropped.mp4");
            desktopVideoRef.current.load();
            mobileVideoRef.current.load();
          } else {
            mobileVideoRef.current.poster = mobileVideoRef.current.poster.replace("3-cropped.jpg", "1-cropped.jpg");
            desktopVideoRef.current.poster = desktopVideoRef.current.poster.replace("3-cropped.jpg", "1-cropped.jpg");
            desktopVideoRef.current.src = videoSrc.replace('3-540p.mp4', '1-540p.mp4');
            mobileVideoRef.current.src = mobileVideoRef.current.src.replace("3-cropped.mp4", "1-cropped.mp4");
            desktopVideoRef.current.load();
            mobileVideoRef.current.load();
          }

          desktopVideoRef.current.play();
        };
      }

      // Handle language detection
      try {
        const userLanguage = navigator.language;
        const shortCode = userLanguage.split('-')[0].trim();
        mixpanel.people.set_once({
          navigatorLanguageCode: "navigator.language",
          navigatorLanguage: shortCode === "en" ? "English" : supportedLaguages[shortCode],
        });
        setLanSupport(supportedLaguages[shortCode]);
      } catch (e) {
        console.log(e);
      }

      // Handle player state subscriptions
      const setPlaying = () => setIsPlaying(true);
      const setPaused = () => setIsPlaying(false);

      subscribe('playing', setPlaying);
      subscribe('paused', setPaused);

      return () => {
        unsubscribe('playing', setPlaying);
        unsubscribe('paused', setPaused);
      };
    }, [desktopVideoRef, mobileVideoRef]);
  
    const onClickDemo = (selection) => {
      // setSelectedDemo(selection);
      // setDemoUrl(
      //   `https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/2023/${selection}.mp4`
      // );
    };
  
    const PodcastApp = (src, name) => {
      return (
        <div className="podcast-app-icon-container">
          <img className="podcast-app-icon" src={src} alt={`${name} logo`}></img>
          <br /> {name}
          <br />
        </div>
      );
    };
  
    const renderSignUpButton = () => {
      return (
        <div className="cta-div" style={{ position: 'static', width: 'auto' }}>
          <Link
            to="/signin?source=nav_signup&redirected_from=landingB"
            className="cta-button"
            onClick={(e) => {
              mixpanel.track('Click Sign Up (Nav)', {
                placement: isChrome ? 'Chrome' : 'Edge',
                variant: 'B',
                experiment: 'landing_page_test'
              });
              logConversion('sign_up_click', 'B');
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div>
                <div>Start listening</div>
              </div>
            </div>
          </Link>
        </div>
      );
    };
  
    const renderCta = (placement = '') => {
      return (
        <div className="cta-div" style={{ position: 'static' }}>
          <Link
            to="/signin?source=nav_cta&redirected_from=landingB"
            className="cta-button"
            onClick={(e) => {
              mixpanel.track('Click To Try Now', {
                placement: placement,
                variant: 'B',
                experiment: 'landing_page_test'
              });
              logConversion('try_for_free_click', 'B');
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
              <div>
                <div>{cta}</div>
              </div>
            </div>
          </Link>
        </div>
      );
    };
  
    const [isMenuOpen, setIsMenuOpen] = useState(false);
  
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };
  
    const [isYearly, setIsYearly] = useState(false);
  
    const handleVoiceChange = async (articleId, newVoice) => {
      // Find the article
      const article = popularArticles.find(a => a.article_id === articleId);
      if (!article) return;

      try {
        // Call API to reprocess with new voice
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reprocess`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            article_id: articleId,
            voice: newVoice
          })
        });

        if (response.ok) {
          const updatedArticle = await response.json();
          
          // Update the articles list with new audio URL
          setPopularArticles(articles => 
            articles.map(a => 
              a.article_id === articleId 
                ? { ...a, voice: newVoice, audio_url: updatedArticle.audio_url }
                : a
            )
          );

          // If this was the currently playing article, update it
          if (currentArticle?.article_id === articleId) {
            setCurrentArticle(prev => ({
              ...prev,
              voice: newVoice,
              audio_url: updatedArticle.audio_url
            }));
          }

          // Track voice change in analytics
          mixpanel.track('Change Article Voice', {
            article_id: articleId,
            new_voice: newVoice,
            old_voice: article.voice || 'Matthew'
          });
        }
      } catch (error) {
        console.error('Error changing voice:', error);
        // You might want to show an error notification here
      }
    };
  
    const [allFeeds, setAllFeeds] = useState([]);
    const [displayedFeeds, setDisplayedFeeds] = useState([]);
    const [feedsLoading, setFeedsLoading] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const observer = useRef();
    const loadingRef = useRef();
    const FEEDS_PER_PAGE = 10;

    const loadMoreFeeds = useCallback(() => {
      if (!feedsLoading && hasMore) {
        const start = page * FEEDS_PER_PAGE;
        const end = start + FEEDS_PER_PAGE;
        const newFeeds = allFeeds.slice(start, end);
        
        if (newFeeds.length > 0) {
          setDisplayedFeeds(prev => [...prev, ...newFeeds]);
          setPage(prev => prev + 1);
          setHasMore(end < allFeeds.length);
        } else {
          setHasMore(false);
        }
      }
    }, [page, allFeeds, feedsLoading, hasMore]);

    // Add intersection observer effect
    useEffect(() => {
      if (loadingRef.current && hasMore) {
        observer.current = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && hasMore) {
            loadMoreFeeds();
          }
        }, { threshold: 0.5 });

        observer.current.observe(loadingRef.current);
      }

      return () => {
        if (observer.current) {
          observer.current.disconnect();
        }
      };
    }, [loadMoreFeeds, hasMore]);

    // Add feeds loading effect
    useEffect(() => {
      getAllFeeds()
        .then(async (response) => {
          if (response && response.data && response.data.feeds) {
            const processedFeeds = response.data.feeds.map(feed => {
              return {
                ...feed,
                feed_id: feed.feed_id || feed.id || `feed-${Math.random()}`,
                title: feed.title || feed.name || "Untitled Feed",
                date_added: feed.date_added || feed.created_at || new Date().toISOString(),
                article_id: feed.last_article_url || feed.feed_id || feed.id,
                audio_url: feed.audio_url || "https://audioread.com/share/placeholder.mp3",
              };
            });
            
            const feedsWithThumbnails = await Promise.all(
              processedFeeds.map(async (feed) => {
                try {
                  if (feed.feed_id) {
                    const latestArticle = await getLatestFeedArticleFromFeed(feed.feed_id);
                    
                    if (latestArticle) {
                      return {
                        ...feed,
                        thumbnail_url: latestArticle.thumbnail_url || feed.thumbnail_url,
                        audio_url: latestArticle.audio_url,
                        article_id: latestArticle.article_id,
                        article_title: latestArticle.title,
                        article_url: latestArticle.url,
                        latestArticle: latestArticle
                      };
                    }
                  }
                  return feed;
                } catch (error) {
                  console.error(`Error fetching latest article for feed ${feed.feed_id}:`, error);
                  return feed;
                }
              })
            );
            
            setAllFeeds(feedsWithThumbnails);
            setDisplayedFeeds(feedsWithThumbnails.slice(0, FEEDS_PER_PAGE));
            setPage(1);
            setHasMore(feedsWithThumbnails.length > FEEDS_PER_PAGE);
          }
          setFeedsLoading(false);
        })
        .catch(error => {
          console.error("Error fetching feeds:", error);
          setFeedsLoading(false);
        });
    }, []);
  
    return (
      <div className="App">
        <header
          className="App-header"
          style={{
            // paddingTop: '10%',
            minHeight: '100vh'
          }}
        >
          <div className="nav-bar ">
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ position: "relative" }} className="logo-container">
              <img className="audiblogs-logo" src={logo} alt="logo" />
                <ProBadge />
              </div>
              <div style={{ marginLeft: '50px' }} className="ph-badge">
                <a
                  href="https://www.producthunt.com/posts/audiblogs?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-audiblogs"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=283759&theme=dark&period=monthly"
                    alt="Audioread - Listen to any web article in your podcast player | Product Hunt"
                    style={{
                      width: '250px',
                      height: '54px',
                    }}
                    width="250"
                    height="54"
                  />
                </a>
              </div>
            </div>
  
            {/* Desktop Navigation */}
            <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px', fontSize: '1.05rem', fontWeight: 'bold' }}>
                <Link
                  className="signin-button"
                  to="/signin?source=nav_signin&redirected_from=landingB"
                  onClick={(e) => {
                    mixpanel.track('Click Log In on Landing Page');
                  }}
                >
                  Sign In
                </Link>
              </div>
              <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)', marginLeft: '-20px'}}>
                {renderSignUpButton()}
              </div>
            </div>
  
            {/* Mobile Navigation */}
            <div className="mobile-nav">
              <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)', paddingBottom: '15px', marginRight: '-10px'}}>
                {renderSignUpButton()}
              </div>
              {/* <button 
                onClick={toggleMenu}
                style={{
                  background: 'none', 
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  position: 'absolute',
                  marginTop: '10px',
                  right: '0px',
                  alignItems: 'center'
                }}
              >
                {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </button> */}
              
              {/* Mobile Menu */}
              {isMenuOpen && (
                <div 
                  style={{
                    position: 'fixed',
                    top: '60px',
                    right: '20px',
                    backgroundColor: 'rgba(9, 2, 19, 0.95)',
                    padding: '20px',
                    width: '200px',
                    borderRadius: '10px',
                    backdropFilter: 'blur(10px)',
                    zIndex: 1000,
                    boxSizing: 'border-box'
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <Link
                      to="/feeds"
                      className="mobile-menu-link"
                      onClick={() => {
                        mixpanel.track('Click Feeds on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Feeds
                    </Link>
                    <Link
                      className="signin-button"
                      to="/freeaitexttospeech"
                      onClick={(e) => {
                        mixpanel.track('Click Free Text to Speech on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Free Converter Tool
                    </Link>
                    <Link
                      className="signin-button"
                      to="/signin?source=nav_signin&redirected_from=landingB"
                      onClick={(e) => {
                        mixpanel.track('Click Log In on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Sign In
                    </Link>
                    <Link
                      className="signin-button"
                      to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => {
                        mixpanel.track('Click Use Cases on Landing Page');
                        setIsMenuOpen(false);
                      }}
                    >
                      Use Cases
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
  
          <h1 className="bigger-headline" style={{ marginTop: '80px' }}>
            Read More. Easily.
          </h1>
  
          <h2 className="subheadline">
          Convert articles, PDFs, emails, rss feeds, and more into human-like audio
          <br />
          Listen in your podcast player and "Read" while walking, driving, cleaning, and more
            {lanSupport && <><br></br> ✅ Supports {lanSupport}</>}
          </h2>
          {renderCta('Listen to any article')}
          <div
            className='demo-video-container'
          // style={{ margin: '10px 0' }}
          >
            <video
              className='desktop-video'
              ref={desktopVideoRef}
              autoPlay
              playsInline
              loading="lazy"
              // loop
              loop={false}
              muted
              poster={'https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p.jpg'}
              src={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/desktop-1-540p.mp4`}
              type="video/mp4"
            // style={{
            //   // height: '600px',
            //   maxWidth: '800px',
            //   borderRadius: '15px',
            //   position: "relative",
            //   right: "-150px",
            //   marginTop: "25px"
            // }}
            />
            <video
              className='mobile-video'
              loop={false}
  
              ref={mobileVideoRef}
              // autoPlay
              playsInline
              loading="lazy"
              // loop
              muted
              poster={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/iphone-1-cropped.jpg`}
              src={`https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/demo-sequence/iphone-1-cropped.mp4`}
              type="video/mp4"
            // style={{
            //   // height: '600px',
            //   position: "relative",
            //   top: "20px",
            //   left: "-700px",
            //   height: "500px",
            //   borderRadius: "15px",
            //   boxShadow: "0px 10px 20px 0px rgba(0,0,0,0.50)"
            //   }}
            />
  
  
          </div>
  
        </header>

        {/* Benefits Tiles Section */}
        <div className="App-header" style={{ minHeight: '85vh', margin: '0 auto', marginTop: '-50px' }}>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              
              @media (max-width: 768px) {
                .benefits-grid {
                  grid-template-columns: 1fr !important;
                  gap: 20px !important;
                  padding: 0 15px !important;
                  max-width: 100vw !important;
                  overflow: hidden !important;
                }
                
                .benefits-grid > div {
                  min-width: auto !important;
                  width: 100% !important;
                  max-width: calc(100vw - 30px) !important;
                  box-sizing: border-box !important;
                }
              }
              
              @media (max-width: 480px) {
                .benefits-grid {
                  padding: 0 10px !important;
                  gap: 15px !important;
                  max-width: 100vw !important;
                }
                
                .benefits-grid > div {
                  max-width: calc(100vw - 20px) !important;
                }
              }
            `}
          </style>
          <h1 className="headline" style={{ marginBottom: '50px' }}>
            Why Choose Audioread?
          </h1>
          
          <div className="benefits-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '20px',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 20px',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            
            {/* Human-like Voices */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden'
            }} 
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Human-like Voices</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center', marginBottom: '20px' }}>
                Ultra-realistic AI voices that sound indistinguishable from human narrators. Perfect for long-form listening.
              </p>
              
              {/* Thomas Frank Quote */}
              <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '15px',
                padding: '20px',
                marginBottom: '20px',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}>
                <p style={{ 
                  color: '#fff', 
                  fontSize: '18px', 
                  fontStyle: 'italic', 
                  textAlign: 'center',
                  marginBottom: '15px',
                  fontWeight: '500'
                }}>
                  "It sounds scarily good"
                </p>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}>
                  <img
                    src="https://yt3.ggpht.com/ytc/AKedOLTGr4Z50rSM01ou6Ek6iCZVuAu_AZOW2v8RJfrMcw=s176-c-k-c0x00ffffff-no-rj-mo"
                    style={{
                      borderRadius: '50%',
                      height: '40px',
                      width: '40px'
                    }}
                    alt="Thomas Frank"
                  />
                  <span style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>
                    Thomas Frank (YouTuber)
                  </span>
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, #4292fa, #8535cd)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)';
                  e.currentTarget.style.boxShadow = '0 10px 20px rgba(66, 146, 250, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                onClick={async () => {
                  // If audio is already playing, pause it
                  if (audioPlaying) {
                    if (window.currentAudio) {
                      window.currentAudio.pause();
                      setAudioPlaying(false);
                    }
                    return;
                  }
                  
                  try {
                    setAudioLoading(true);
                    
                    // Create audio element with preload
                    const audio = new Audio();
                    audio.preload = 'auto';
                    
                    // Store reference globally so we can pause it later
                    window.currentAudio = audio;
                    
                    // Add event listeners for better user feedback
                    audio.addEventListener('loadstart', () => {
                      console.log('Audio loading started');
                    });
                    
                    audio.addEventListener('canplay', () => {
                      console.log('Audio can play');
                      setAudioLoading(false);
                    });
                    
                    audio.addEventListener('play', () => {
                      setAudioPlaying(true);
                      setAudioLoading(false);
                    });
                    
                    audio.addEventListener('pause', () => {
                      setAudioPlaying(false);
                    });
                    
                    audio.addEventListener('ended', () => {
                      setAudioPlaying(false);
                      window.currentAudio = null;
                    });
                    
                    audio.addEventListener('error', (e) => {
                      console.error('Audio error:', e);
                      setAudioLoading(false);
                      setAudioPlaying(false);
                      window.currentAudio = null;
                    });
                    
                    // Set the source and try to play
                    // Try multiple audio sources in case one fails
                    const audioSources = ['https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/samples/Sierra.mp3'];
                    
                    audio.src = audioSources[0];
                    
                    // Debug: log the audio element
                    console.log('Audio element created:', audio);
                    console.log('Audio source set to:', audio.src);
                    
                    // Try to play the audio
                    const playPromise = audio.play();
                    
                    if (playPromise !== undefined) {
                      playPromise
                        .then(() => {
                          console.log('Audio playing successfully');
                        })
                        .catch(error => {
                          console.error('Playback failed:', error);
                          setAudioLoading(false);
                          
                          // Try alternative approach - try different audio sources
                          console.log('First audio source failed, trying alternatives...');
                          
                          for (let i = 1; i < audioSources.length; i++) {
                            try {
                              const fallbackAudio = new Audio(audioSources[i]);
                              console.log('Trying audio source:', audioSources[i]);
                              
                              const fallbackPromise = fallbackAudio.play();
                              if (fallbackPromise !== undefined) {
                                fallbackPromise.then(() => {
                                  console.log('Fallback audio playing successfully from:', audioSources[i]);
                                  setAudioLoading(false);
                                  setAudioPlaying(true);
                                  window.currentAudio = fallbackAudio;
                                  return;
                                }).catch(e => {
                                  console.error('Fallback audio failed:', audioSources[i], e);
                                  if (i === audioSources.length - 1) {
                                    // All sources failed
                                    setAudioLoading(false);
                                    alert('Unable to play any audio samples. This might be due to browser autoplay restrictions or network issues.');
                                  }
                                });
                              }
                              break;
                            } catch (e) {
                              console.error('Error creating fallback audio:', e);
                            }
                          }
                        });
                    }
                  } catch (error) {
                    console.error('Audio creation failed:', error);
                    setAudioLoading(false);
                    alert('Unable to load audio sample. Please try again later.');
                  }
                }}>
                  {audioLoading ? (
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '2px solid #fff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                  ) : audioPlaying ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="6" y="4" width="4" height="16" />
                      <rect x="14" y="4" width="4" height="16" />
                    </svg>
                  ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polygon points="5,3 19,12 5,21"></polygon>
                    </svg>
                  )}
                </div>
              </div>
            </div>

            {/* Convert in 2 Clicks */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Convert in 2 Clicks</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center', marginBottom: '20px' }}>
                Works on any device with browser extensions, mobile apps, and shortcuts. Convert emails, PDFs, and web articles instantly.
              </p>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '15px',
                justifyContent: 'center',
                maxWidth: '200px',
                margin: '0 auto'
              }}>
                <img src={Chrome} style={{ width: '40px', height: '40px' }} alt="Chrome" />
                <img src={Safari} style={{ width: '40px', height: '40px' }} alt="Safari" />
                <AppleIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <AndroidIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <ForwardToInboxIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <PictureAsPdfIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <RssFeedIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <BookIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
                <ContentPasteIcon style={{ width: '40px', height: '40px', color: '#fff' }} />
              </div>
            </div>

            {/* Podcast Player Integration */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(133, 53, 205, 0.1), rgba(66, 146, 250, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Listen in Your Podcast Player...or in Your Browser (No App Required!)</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center', marginBottom: '20px' }}>
                Get a private RSS feed and listen in any podcast app, or use the web player directly in your browser. Perfect for multitasking and learning on the go.
              </p>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px',
                justifyContent: 'center'
              }}>
                <img src={applepodcasts} style={{ width: '40px', height: '40px' }} alt="Apple Podcasts" />
                <img src={spotify} style={{ width: '40px', height: '40px' }} alt="Spotify" />
                <img src={youtube} style={{ width: '40px', height: '40px' }} alt="YouTube Music" />
                <img src={overcast} style={{ width: '40px', height: '40px' }} alt="Overcast" />
              </div>
            </div>

            {/* 80+ Languages */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                🌍
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>80+ Languages</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Support for major world languages with natural-sounding voices in each language.
              </p>
            </div>

            {/* Download Audio */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                ⬇️
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Download Your Audio</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Save MP3 files locally for offline listening or use in other applications.
              </p>
            </div>

            {/* AI Summaries */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                🤖
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>AI Summaries</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Get intelligent summaries of your content to quickly understand key points.
              </p>
            </div>

            {/* Best Value */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                💎
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Best Value in the Market</h3>
              <p style={{ color: '#4292fa', fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px' }}>
                Starting at $5.83/month
              </p>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Premium quality at competitive prices. Get more for your money with Audioread.
              </p>
            </div>

            {/* Playback Speed Control */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                ⚡
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Adjust Playback Speed</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Control listening speed from 0.5x to 3x to match your learning pace and time constraints.
              </p>
            </div>

            {/* Transcripts */}
            {/* <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                📝
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Get Transcripts</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Access written transcripts of your audio content for easy reference and note-taking.
              </p>
            </div> */}

            {/* Privacy Mode */}
            <div style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1), rgba(133, 53, 205, 0.1))',
              borderRadius: '20px',
              padding: '30px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '20px',
                textAlign: 'center',
                color: '#4292fa'
              }}>
                🔒
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '15px', color: '#fff', textAlign: 'center' }}>Privacy Mode</h3>
              <p style={{ color: '#ccc', lineHeight: '1.6', textAlign: 'center' }}>
                Keep your content private with auto-deletion after 30 days, no sharing, and exclusion from search engines.
              </p>
            </div>
          </div>
        </div>

        <div
          className="App-header"
          id="tweets"
          style={{
            minHeight: '85vh',
            display: 'flex',
            flexDirection: 'column',
            margin: '0 auto',
            marginTop: '-50px'
          }}
        >
          <h1 className="headline">
            What our customers say
          </h1>
          <h2 className="subheadline">
            Join thousands of satisfied users who love listening to their content with Audioread
          </h2>

          <Testimonials />
        </div>

        <div className="App-header" id="tweets" style={{ minHeight: '85vh' }}>
          <h1 className="headline">
            Pricing
          </h1>

          <PricingCards 
            onPlanSelect={() => {}}
            selectedPlan=""
            showPaymentElement={false}
            estimateAudioDuration={(chars) => Math.round((chars / 10000) * 10.5)}
            renderCta={renderCta}
          />
        </div>

        {/* Popular Feeds Section */}
        {/* <div className="App-header" style={{ minHeight: '85vh' }}>
          <h1 className="headline">
            Popular Feeds
          </h1>
          <div className="article-container" style={{ 
            marginTop: "50px", 
            marginBottom: "50px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, 300px)",
            gap: "20px",
            paddingRight: "30px",
            width: "100%",
            maxWidth: "1200px",
            margin: "50px auto",
            justifyContent: "center"
          }}>
            {feedsLoading ? (
              <div className="feeds-loading-container" style={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                padding: '100px 20px',
                gap: '20px',
                gridColumn: "1 / -1"
              }}>
                <CircularProgress 
                  size={40} 
                  sx={{
                    color: '#4292fa',
                    '@keyframes gradient': {
                      '0%': { color: '#4292fa' },
                      '25%': { color: '#8535cd' },
                      '50%': { color: '#e82186' },
                      '75%': { color: '#ff5c57' },
                      '100%': { color: '#4292fa' }
                    },
                    animation: 'gradient 2s ease infinite'
                  }}
                />
                <p style={{ 
                  color: '#fff',
                  fontSize: '16px',
                  fontWeight: 500,
                  background: 'linear-gradient(90deg, #4292fa, #8535cd, #e82186, #ff5c57)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundSize: '300% 100%',
                  animation: 'gradient 2s ease infinite'
                }}>Loading feeds...</p>
              </div>
            ) : (
              <>
                {displayedFeeds.slice(0, 9).map((feed) => (
                  <Link 
                    key={feed.feed_id || feed.id || Math.random().toString()}
                    to={`/signin?source=landing_page_feed_card&redirected_from=landingB`}
                    style={{
                      textDecoration: 'none',
                      color: 'inherit',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      display: 'block',
                      width: '100%'
                    }}
                    className="feed-link"
                  >
                    <FeedSubscribed
                      feed={feed}
                      idToken={null}
                      selectArticle={() => {}}
                      isActive={false}
                      onUnsubscribe={() => {}}
                      isSubscribed={false}
                    />
                  </Link>
                ))}
              </>
            )}
          </div>
        </div> */}

        <div className="App-header" style={{ marginTop: '-100px' }}>
          <h1 className="headline">
            Don't have time to read?
          </h1>
          <h2 className="subheadline">Start audioreading! Do more with your time. <br></br></h2>
          {renderCta('No one has time to read')}
        </div>
        {/* <OneGiftLogo /> */}
        <div className="footer-links" style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/dmca">DMCA Policy</Link>
          <a href="https://audioread.tolt.io/" target="_blank" rel="noopener noreferrer">Affiliate Program</a>
        </div>
        <div style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <a href="mailto:info@audioread.com" target="_blank" rel="noopener noreferrer">
            Contact us at info@audioread.com
          </a>
        </div>
        <div style={{ margin: '25px', opacity: 0.7 }}>© {new Date().getFullYear()} Audioread™. All rights reserved.</div>
      </div>
    );
  });

export default LandingB; 